import React    from 'react'
import Loadable from 'react-loadable'

const LoadableDatePicker = Loadable({
  loader: () => import('./DatePicker'),
  loading: () => <div>Loading...</div>,
})

export const DatePicker = (props) => <LoadableDatePicker {...props} />
